export default __webpack_public_path__ + "static/media/img1.4de08fe0.png";